import * as turf from '@turf/turf';
import { Feature, FeatureCollection, Point as GeoJSONPoint, Polygon } from 'geojson';

interface Point {
  longitude: number;
  latitude: number;
  evacuationPerimeterM?: number;
  [key: string]: any;
}

interface PointFeatureCollection {
  type: 'FeatureCollection';
  features: Array<Feature<GeoJSONPoint, Omit<Point, 'longitude' | 'latitude'>>>;
}

export const pointsToGeoJSON = (points: Point[]): PointFeatureCollection => {
  return {
    type: 'FeatureCollection',
    features: points.map((point) => {
      const { longitude, latitude, ...properties } = point;
      return {
        type: 'Feature',
        properties: properties,
        geometry: {
          type: 'Point',
          coordinates: [longitude, latitude],
        },
      };
    }),
  };
};

export const generateCirclesGeoJSON = (points: Point[]): FeatureCollection<Polygon> => {
  const features = points.map((point) => {
    const { evacuationPerimeterM, latitude, longitude } = point;
    const center: [number, number] = [longitude, latitude];
    const radius = (evacuationPerimeterM || 0) / 1000; // Convert to kilometers
    const options = { steps: 64, units: 'kilometers' as turf.Units };
    const circle = turf.circle(center, radius, options);
    return circle;
  });
  return turf.featureCollection(features);
};
